// extracted by mini-css-extract-plugin
module.exports = {"SignatureCard":"SignatureCard_SignatureCard__3O3vy","Border":"SignatureCard_Border__3R_Er"};